module.exports = __webpack_public_path__ + "static/media/adobe-xd.10baff4c.svg";